<div class="mat-typography" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <h2 mat-dialog-title cdkDragHandle>Transfer Asset - {{this.asset.description}}</h2>
  <mat-dialog-content>
    <form class="transfer-asset" [formGroup]="form">

      <div>
        <mat-form-field class="select-half-width" matTooltip="Select a Business Unit from the list">
          <mat-label i18n="@@type.Asset.businessUnit">Business Unit</mat-label>
          <mat-select formControlName="businessUnit" id="businessUnit" [(ngModel)]="businessUnit"              
              (ngModelChange)="businessUnitChanged()"              
              placeholder="Business Unit" [compareWith]="compareBusinessUnit">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let businessUnit of businessUnitSelectionList" [value]="businessUnit">
              {{businessUnit?.buId}} - {{businessUnit?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div>
      <span>
        <mat-form-field class="select-half-width" matTooltip="Select a Cost Centre from the list">
          <mat-label i18n="@@type.Asset.costCentre">Cost Centre</mat-label>
          <mat-select formControlName="costCentre" id="costCentre"  [(ngModel)]="costCentre"              
              (ngModelChange)="costCentreChanged()"              
              placeholder="Cost Centre" [compareWith]="costCentreCompare">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let costCentre of costCentreSelectionList" [value]="costCentre">
              {{costCentre?.ccId}} - {{costCentre?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        </span>
      </div>

      <div>
        <mat-form-field matTooltip="Comments" class="crud-item-input-verywide">
          <mat-label i18n="@@type.TransferAsset.comments">Comments</mat-label>
          <textarea  matInput formControlName="comments" id="comments"             
              [(ngModel)]="comments" maxlength="1000" placeholder="Comments">
          </textarea>
        </mat-form-field>
      </div>
      
    </form>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="closeDialog()">Cancel</button>
    <button mat-raised-button color="primary" (click)="createTransferAsset()" disabled="{{!isCreateTransferEnabled()}}">Create Transfer</button>
  </mat-dialog-actions>
</div>
